import React, { useEffect } from 'react';
import Slider from 'react-slick';
import { Drawer } from 'antd';
import ShareLike from '../ShareLike/ShareLike';
import { CloseIcon, ChevronLeft, ChevronRight } from '../../assets/icons';
import './PropertySlider.scss';
import { Images } from '../../config/images';

const PropertySlickSlider = React.forwardRef((props, slider) => {
  const { setIndex, index, sliderOpen, setSliderOpen, images } = props;
  const settings2 = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: true,
    fade: true,
    afterChange: (firstArgument) => setIndex(firstArgument),
  };

  useEffect(() => {
    setIndex(index);
    return () => {
      setIndex(-1);
    };
  }, [sliderOpen]);

  return (
    <>
      <Drawer
        open={sliderOpen}
        className='slider-drawer'
        onClose={() => setSliderOpen(false)}
        width='100%'
        headerStyle={{ display: 'none' }}
        footer={false}
      >
        <div className='slider-head'>
          <div className='d-flex slider-head__close'>
            <CloseIcon className='cursor-pointer' size={24} marginRight='8px' onClick={() => setSliderOpen(false)} />
            <span className='fw-600 fz-16 d-sm'>Close</span>
          </div>
          <div className='fz-16 slider-head__number'>{`${index + 1} / ${images.length}`}</div>
          <ShareLike className='ml-auto small-font' />
        </div>
        <div className='slider-wrapper'>
          <Slider initialSlide={index} ref={(c) => (slider.current = c)} {...settings2}>
            {React.Children.toArray(
              images?.map((item, id) => (
                <img
                  onError={(element) => {
                    element.target.src = Images.noPropertyFoundImage;
                  }}
                  src={item}
                  alt={`property ${id}`}
                  loading='lazy'
                />
              ))
            )}
          </Slider>
          {index > 0 && (
            <button
              className='arrow arrow--prev'
              onClick={() => {
                setIndex(index - 1);
                slider.current.innerSlider.slideHandler(index - 1);
              }}
            >
              <ChevronLeft verticalAlign='-7px' size={24} color='#1A1519' />
            </button>
          )}
          {index < images.length - 1 && (
            <button
              className='arrow arrow--next'
              onClick={() => {
                setIndex(index + 1);
                slider.current.innerSlider.slideHandler(index + 1);
              }}
            >
              <ChevronRight verticalAlign='-7px' size={24} color='#1A1519' />
            </button>
          )}
        </div>
      </Drawer>
    </>
  );
});

export default PropertySlickSlider;
